import { sendFeedbackEmail } from '../mailing'
import type { FeedbackPayload } from '../mailing.type'

export async function submitFeedback(payload: FeedbackPayload): Promise<void> {
  await sendFeedbackEmail(payload)
}
